export enum NafathCheckStatuses {
    COMPLETED = 1,
    WAITING = 2,
    EXPIRED = 3,
    REJECTED = 4
}
